<template>
  <HomeLayout>
    <div :class="['me-content', { 'me-content-not': !isActive }]">
      <Block :class="['mb48', 'user-block', { 'user-block-not': !isActive }]">
        <md-cell-item>
          <img
            slot="left"
            :src="require(`@/assets/${isActive ? 'high-user' : 'user-icon'}.png`)"
            class="holder"
          >
          <!-- 已激活 -->
          <template v-if="isActive">
            <div class="user-tag dib mr12 is-active">
              <img :src="require('@/assets/verified.png')">
              {{ $t('verifiedLow') }}
            </div>

            <br>

            {{ userName }}
          </template>

          <!-- 审核被拒绝 -->
          <template v-else-if="isUnPassed">
            <div class="user-tag dib mr12 rejected">
              {{ $t('review_rejected') }}
            </div>
          </template>

          <!-- 未激活标志，并展示激活按钮 -->
          <template v-else>
            <span class="user-tag dib mr12">
              <img :src="require('@/assets/low-icon.png')">
              {{ $t('unverified') }}
            </span>
            <span class="f24 blue" @click="handleToActivate">
              {{ $t('activate_wallet') }}
            </span>
          </template>
        </md-cell-item>

        <UserInfo v-if="isActive" />
      </Block>

      <div class="user-block-down pb20">
        <router-link :to="{ name: 'MeInfo' }">
          <Block class="mb32 my-block-item">
            <md-cell-item :title="$t('personaInformation')" arrow>
              <span slot="left" class="holder">
                <svg-icon name="me-user" />
              </span>
            </md-cell-item>
          </Block>
        </router-link>
        <router-link :to="{ name: 'MePaySet' }">
          <Block class="mb32 my-block-item">
            <md-cell-item :title="$t('paymentSettings')" arrow>
              <span slot="left" class="holder">
                <svg-icon name="me-card" class="icon-card" />
              </span>
            </md-cell-item>
          </Block>
        </router-link>
        <router-link :to="{ name: 'MeContactUs' }">
          <Block class="mb32 my-block-item">
            <md-cell-item :title="$t('contact_us')" arrow>
              <span slot="left" class="holder">
                <svg-icon name="contact-number" />
              </span>
            </md-cell-item>
          </Block>
        </router-link>
        <router-link :to="{ name: 'MeAboutFlashPay' }">
          <Block class="mb32 my-block-item">
            <md-cell-item :title="$t('about_flashpay')" arrow>
              <span slot="left" class="holder">
                <svg-icon name="about_icon" />
              </span>
            </md-cell-item>
          </Block>
        </router-link>
        <router-link :to="{ name: 'FAQ' }">
          <Block class="my-block-item">
            <md-cell-item :title="$t('faq')" arrow>
              <span slot="left" class="holder">
                <svg-icon name="faq" />
              </span>
            </md-cell-item>
          </Block>
        </router-link>
      </div>
      <div class="logout">
        <md-button type="primary" @click="logout">
          {{ $t('log_out') }}
        </md-button>
      </div>
      <div class="logout">
        <md-button type="warning" plain @click="handleCancellation">
          {{ $t('delete_account') }}
        </md-button>

        <md-dialog
          v-model="showCancellationDialog"
          :closable="true"
          :btns="actions"
          :title="$t('confirm_cancellation')"
        >
          {{ $t('cancellation_message') }}
        </md-dialog>

        <PasswordPopup
          v-model="showPasswordPopup"
          :error.sync="passwordError"
          :code.sync="password"
          @finished="handleConfirm"
        />
      </div>
    </div>
  </HomeLayout>
</template>

<script>
// 我的页面
import Block from '@/components/Block'
import UserInfo from '@/views/Me/components/UserInfo'
import { CellItem, Button, Dialog } from 'mand-mobile'
import HomeLayout from '@/layout/HomeLayout'
import PasswordPopup from '@/components/PasswordPopup'
import { userCancel, logoutApi } from '@/api/me'
import { ERROR_REQ_CODE } from '@/constants'
import global from '@/utils/global'

const auditStatus = {
  init: 0, // 未识别
  pass: 1, // 通过
  unPassed: 2, // 未通过
  audit: 3 // 待审核
}

export default {
  name: 'Me',

  components: {
    Block,
    [CellItem.name]: CellItem,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    UserInfo,
    HomeLayout,
    PasswordPopup
  },

  data () {
    return {
      showCancellationDialog: false,
      showPasswordPopup: false,
      password: '',
      passwordError: '',
      actions: [
        {
          text: this.$t('cancel'),
          handler: this.onBasicCancel
        },
        {
          text: this.$t('confirm'),
          warning: true,
          handler: this.onBasicConfirm
        }
      ]
    }
  },

  computed: {
    userName () {
      return this.$store.state?.common?.certificateLevel?.name
    },

    // 已经通过审核了
    isActive () {
      return this.$store.state?.common?.certificateLevel?.auditStatus?.code === auditStatus.pass
    },

    // 审核被拒绝了
    isUnPassed () {
      return this.$store.state?.common?.certificateLevel?.auditStatus?.code === auditStatus.unPassed
    }
  },

  methods: {
    handleToActivate () {
      this.$store.commit('change_agreementVisible', true)
    },
    onBasicConfirm () {
      this.showCancellationDialog = false
      this.showPasswordPopup = true
    },
    async logout () {
      await logoutApi()
      global.removeCookie()
      this.$router.replace({ name: 'Login' })
    },

    handleCancellation () {
      this.showCancellationDialog = true
    },

    async handleConfirm (password) {
      try {
        await userCancel({ password })

        await this.logout()
      } catch (e) {
        this.passwordVisiable = false // 键盘隐藏
        if (e.code === ERROR_REQ_CODE.passError) {
          // 密码错误
          this.passwordVisiable = true // 键盘显示
        }
        this.passwordError = e.message
        this.password = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */
.me-content {
  height: 308px;
  width: 750px;
  background: linear-gradient(180deg, #ffea33, #fff);
  box-sizing: border-box;
}

.user-block-not {
  margin-bottom: 0 !important;

  ::v-deep .flash-block__content {
    background-color: #ffea33;
    box-shadow: none;

    .md-cell-item-body {
      padding: 40px 8px !important;
    }
  }
}

.me-content-not {
  background: #ffea33;

  .user-block-down {
    width: 100%;
    background: #fff;
    border-radius: 72px 72px 0 0;
    padding-top: 68px;
  }
}

.logout {
  margin: 20px 30px;
  padding-bottom: 10px;
}

.user-block {
  margin: 0 40px;

  .holder {
    width: 96px;
    height: 96px;
    border-radius: 44px;
  }

  .user-tag {
    padding: 0 16px;
    height: 48px;
    background: #fff3df;
    border-radius: 8px;
    line-height: 48px;
    font-size: 24px;
    text-align: center;

    img {
      width: 36px;
      height: 36px;
      vertical-align: middle;
      margin-right: 12px;
    }

    &.is-active {
      background: #d7efe3;
    }

    &.rejected {
      background: #fa8787;
    }
  }

  ::v-deep .flash-block__content {
    border-radius: 32px;

    .md-cell-item-left {
      margin-right: 24px;
    }

    .flash-block_body {
      padding: 0;
    }

    .md-cell-item-body {
      padding: 36px 48px;

      &::before {
        display: none;
      }
    }
  }
}

.my-block-item {
  margin: 0 40px;

  ::v-deep .flash-block__content {
    border-radius: 32px;

    .flash-block_body {
      padding: 0 40px 0 36px;
    }

    .md-cell-item-body {
      padding-top: 54px;
      padding-bottom: 54px;

      &::before {
        display: none;
      }
    }

    .md-cell-item-title {
      font-weight: 700;
    }

    .holder {
      width: 64px;
      height: 64px;
      border-radius: 32px;

      .svg-icon {
        color: #ffc300;
        width: 48px;
        height: 48px;
      }

      .icon-card {
        color: #58a8fc;
      }

      .me-settings {
        color: #06cdbb;
      }
    }

    .md-cell-item-left {
      margin-right: 28px;
    }
  }
  /* stylelint-enable */
}
</style>
